<div class="pw-login-container">
  <app-mobile-header [title]="'button.login'" [manualBackEvent]="true"
    (onManualBackEvent)="onClickBack()"></app-mobile-header>

  <div class="pwLogin-content">
    <div class="pwLogin-mascot">
      <img src="assets/generalImage/user.svg" loading="lazy" alt="mascot" />
      <h1 *ngIf="!isSubmittedLogin">{{ "desc.enter.password.to.login" | translate }}</h1>
      <h1 *ngIf="isSubmittedLogin">{{"desc.found.account" | translate}}</h1>
    </div>

    <form (ngSubmit)="onSubmit()" (keyup.enter)="onSubmit()" [formGroup]="fgroup" class="pwloginform">
      <div class="mobile-field">
        <ngx-intl-tel-input [enableAutoCountrySelect]="telInpSetting.enableAutoCountrySelect" [cssClass]=""
          [customPlaceholder]="telInpSetting.customPlaceholder | translate"
          [enablePlaceholder]="telInpSetting.enablePlaceholder" [searchCountryFlag]="telInpSetting.searchCountryFlag"
          [searchCountryField]="telInpSetting.searchCountryField"
          [selectFirstCountry]="telInpSetting.selectFirstCountry" [phoneValidation]="telInpSetting.phoneValidation"
          [inputId]="'phoneNo'" [separateDialCode]="telInpSetting.separateDialCode"
          [preferredCountries]="telInpSetting.preferredCountries"
          [selectedCountryISO]="countryCode | telInputCountryCode" name="phone" formControlName="phoneNo">
        </ngx-intl-tel-input>
      </div>

      <div class="input-outline" [ngClass]="{'invalid-p-inputtext': pwErr && pwErr != null}">
        <span class="p-float-label">
          <input id="password" [type]="showPw? 'text': 'password'" pInputText formControlName="password" #password>
          <label for="password">{{'label.password' | translate}}</label>
        </span>
        <i  class="{{!showPw ? 'icon-eye-close':'icon-eye-open'}}" (click)="showPw = !showPw"></i>

        <i class="icon-alert" *ngIf="pwErr"></i>
      </div>

      <div class="invalid-feeback" *ngIf="pwErr && pwErr != null">
        {{ 'error.invalid.password' | translate }}
      </div>

      <app-button [buttonName]="'button.login' | translate" (click)="onSubmit()" [disabled]="!fgroup.valid "
        class="submit-btn"></app-button>

      <app-button [blackTextButton]="true" [buttonName]="'button.forgot.password' | translate" (onClickEvent)="onForgotPw()"
        class="forgotPassword-btn"></app-button>

      <span class="lable-or">{{'label.or' | translate}}</span>

      <app-button [borderButton]="true" [buttonName]="'button.login.with.otp' | translate" (onClickEvent)="onOtpLogin()"
        class="loginWithOTP-btn"></app-button>
    </form>
  </div>

  <div class="pw-login-footer" *ngIf="showContinueAsGuest">
    <app-button [blackTextButton]="true" [buttonName]="'button.continue.as.guest' | translate" class="continueAsGuest-btn"
      (onClickEvent)="onClickContinueAsGuest()"></app-button>
  </div>
</div>
